import React, { FC } from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from 'components/common/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ManageGroupIcon from '@mui/icons-material/CreateNewFolder';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import MenuItemAddThing from 'components/Wrapper/Sidebar/MenuItemAddThing';
import GroupList from 'components/Wrapper/Sidebar/GroupList';
import { Link } from 'react-router-dom';
import * as urns from 'utils/getUrn';
import { observer } from 'mobx-react';
import useAppStore from 'stores/hooks/useAppStore';
import { EElement } from 'types/app';
import { useTranslation } from 'react-i18next';
import dialogStore, { EDialog } from 'stores/DialogStore';

const Sidebar: FC = () => {
  const appStore = useAppStore();
  const { t } = useTranslation();

  return (
    <>
      <List sx={{ pt: 2 }}>
        <ListItemButton component={Link} to={urns.getDashboardUrn()} selected={appStore.element === EElement.DASHBOARD}>
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText primary={t('menu.dashboard')} />
        </ListItemButton>
        <MenuItemAddThing />
        <ListItemButton onClick={() => dialogStore.open(EDialog.GROUPS_MANAGE_DIALOG)}>
          <ListItemIcon>
            <ManageGroupIcon />
          </ListItemIcon>
          <ListItemText primary={t('menu.manageGroups')} />
        </ListItemButton>
      </List>
      <Divider />
      <GroupList />
    </>
  );
};

export default observer(Sidebar);
